// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Buefy, {DialogProgrammatic} from 'buefy'
import VueFab from 'vue-float-action-button'
import vuetify from '@/plugins/vuetify'
import 'buefy/dist/buefy.css'
import router from './router'
import * as firebase from 'firebase'
import store from './store/store'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

require('@/assets/main.scss')

Vue.use(Buefy, {
  defaultIconPack: 'fas'
})
Vue.use(VueFab)

Vue.mixin({
  methods: {
    globalLogger: function (logText1, logText2) {
      // console.log(logText1, logText2)
    },
    setupTimers: function () {
      document.addEventListener('keypress', resetTimer, false)
      document.addEventListener('mousemove', resetTimer, false)
      document.addEventListener('mousedown', resetTimer, false)
      document.addEventListener('touchmove', resetTimer, false)
      startTimer()
    },
    getNotMigrated: function () {
      return ['A3MjSLimVJVFPFZ2Mg9mh18Ftwl1', 'LhC1E3N53QaYmOvayIA9c9CVbVU2']
    }
  }
})

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  // const requiresPowerAuth = to.matched.some(record => record.meta.requiresPowerAddOn)
  if (requiresAuth && !currentUser) next('Login')
  else if (!requiresAuth && currentUser) next('Clusters')
  else next()
})

const timeoutInMS = 60 * 60 * 1000 // 1 hour
let timeoutId

function handleInactive () {
  if (firebase.auth().currentUser) {
    firebase.auth().signOut()
    DialogProgrammatic.alert({
      title: 'Session expired',
      message: 'You have been logged out. Log in again to continue.',
      confirmText: 'Ok',
      onConfirm: () => {
        router.replace({ name: 'Login' })
      }
    })
  }
}

function startTimer () {
  // setTimeout returns an ID (can be used to start or clear a timer)
  timeoutId = setTimeout(handleInactive, timeoutInMS)
}

function resetTimer () {
  clearTimeout(timeoutId)
  if (firebase.auth().currentUser) {
    startTimer()
  }
}

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(() => {
  let app = ''
  // let userSessionTimeout = null
  firebase.auth().onAuthStateChanged(user => {
    // console.log('on auth state changed')
    if (!app) {
      app = new Vue({
        el: '#app',
        router,
        store,
        vuetify,
        components: { App },
        template: '<App/>'
      })
    }
  })
})



// WEBPACK FOOTER //
// ./src/main.js